"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrderDetails = useOrderDetails;
exports.usePageConfig = usePageConfig;
var _react = require("react");
var _util = require("@ux/util");
/**
 * Get page configuration from `target.ux`, usually the window.
 *
 * @param {Window|Object} target Browser window object or fallback
 * @param {Object} [target.ux] UX configuration object
 * @returns {Object|undefined} page configuration if available.
 * @public
 */
function usePageConfig() {
  let {
    ux
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ux ? ux.page || ux.eldorado && ux.eldorado.page : void 0;
}

/**
 * Get orderId from the querystring parameters.
 *
 * @param {Window|Object} target Browser window object or fallback
 * @returns {Object} order id.
 * @public
 */
function useOrderDetails() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const href = target && target.location && target.location.href;
  return (0, _react.useMemo)(() => {
    if (!href) return;
    const {
      orderId
    } = new _util.URL(href, true).query;
    return orderId;
  }, [href]);
}